/**
 * The outcome ID we'll send to the server once a user makes a purchase.
 */
export const REVENUE_OUTCOME_ID = "os__shopify_revenue";

/**
 * The available outcome IDs.  Currently only supports one.
 */
export type OUTCOME_IDS = typeof REVENUE_OUTCOME_ID;

/**
 * Tags that get applied to players after fetching data from Shopify.
 */
export default interface Outcome {
  id: OUTCOME_IDS;
  value: number;
}
